import { ReactNode } from "react";
import classNames from "../../../../utils/classNames";
import { ArrowTopRightOnSquareIcon, PencilIcon } from "@heroicons/react/24/outline";
import PriceFormat from "../../../../utils/priceFormat";
import CurrencyInput from "./CurrencyInput";

export default function EditableEstimateTile({
  label,
  value,
  icon,
  iconClassName,
  hasOverride,
  lookupUrl,
  isEditing,
  inputValue,
  onInputChange,
  onStartEdit,
  onSave,
  onCancel,
}: {
  label: string;
  value: number | null;
  icon: ReactNode;
  iconClassName: string;
  hasOverride: boolean;
  lookupUrl?: string;
  isEditing: boolean;
  inputValue: string;
  onInputChange: (value: string) => void;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}) {
  return (
    <div
      className={classNames(
        "rounded-lg border p-3 transition-colors",
        hasOverride ? "border-blue-200 bg-blue-50/50" : "border-gray-200 bg-gray-50"
      )}
    >
      <div className="mb-1 flex items-center gap-1.5">
        <span className={classNames("shrink-0", iconClassName)}>{icon}</span>
        <span className="flex-1 text-[10px] font-semibold uppercase tracking-wider leading-tight text-gray-500">
          {label}
        </span>

        {lookupUrl && (
          <a
            href={lookupUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 rounded p-0.5 text-gray-400 transition-colors hover:bg-blue-50 hover:text-blue-600"
            title={`Search eBay for ${label.toLowerCase()}`}
          >
            <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" />
          </a>
        )}

        {!isEditing && (
          <button
            type="button"
            onClick={onStartEdit}
            className="shrink-0 rounded p-0.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-primary-600"
            title={`Edit ${label.toLowerCase()}`}
          >
            <PencilIcon className="h-3 w-3" />
          </button>
        )}
      </div>

      {isEditing ? (
        <CurrencyInput
          value={inputValue}
          onChange={onInputChange}
          onSave={onSave}
          onCancel={onCancel}
          inputClassName="w-full rounded border border-primary-300 px-1.5 py-0.5 text-sm font-bold text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          saveIconClassName="h-3.5 w-3.5"
        />
      ) : (
        <p className="text-sm font-bold text-gray-900">
          {value != null ? (
            PriceFormat(value)
          ) : (
            <button
              type="button"
              onClick={onStartEdit}
              className="text-gray-400 underline decoration-dashed underline-offset-2 transition-colors hover:text-primary-600"
            >
              Add price
            </button>
          )}
        </p>
      )}
    </div>
  );
}